




























import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
import {Form} from "../../../../types/forms";
@Component({
    components: {},
})

export default class CustomDropdown extends Vue {
    @Prop({required: true}) private readonly valuesList!: Array<Form.SelectValue>
    @Prop({required: true}) private readonly placeholder!: string;
    private valueName: string = '';
    private isOpened: boolean = false;
    private searchValue: string = '';
    private isInFocus: boolean = false;

    created(): void
    {
        this.valueName = this.placeholder;
    }

    /**
     * Переключение видимости списка
     * @private
     */
    private toggleListVisibility(): void
    {
        this.isOpened = !this.isOpened;
    }

    /**
     * Скрыть список
     * @private
     */
    private closeList(): void
    {
        this.isOpened = false;
        this.isInFocus = false;
    }

    /**
     * Изменить выбранное значение
     * @private
     */
    private changeValue(value: Form.SelectValue): void
    {
        this.valueName = value.label;
        this.searchValue = '';
        this.closeList();
        this.$emit('change-value', value);
    }

    /**
     * Сбросить занчение
     */
    public resetValue(): void
    {
        this.valueName = this.placeholder;
    }
}
